/* @flow */

import * as React from 'react';

import './trial-gathering-prompt.module.css';

type Props = {|
    children: React.Node,
|};

export function TrialGatheringPrompt(props: Props) {
    return <div styleName='prompt'>{props.children}</div>;
}
